import React from "react";
import "./ResetPassword.scss";

// Types
import Question from "../../../types/Question";

// Services
import ApiService from "../../../services/ApiService";

// Components
import { IonLoading, IonNote } from "@ionic/react";
import { withTranslation } from "react-i18next";
import InputFactory from "../../../components/Factories/Input/InputFactory";
import ModalConfirmation from "../../../components/Modals/ModalConfirmation";

// Styles
import "../../../components/Inputs/Input.scss";

class ResetPassword extends React.Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      formData: {},
      error: null,
      message: null,
      loading: false,
      showModal: false,
      confirmationModalOpen: false,
    };
  }

  cancel() {}

  render() {
    const { t } = this.props;

    return (
      <ModalConfirmation
        isOpen={this.props.isOpen}
        closeModal={this.props.closeModal}
        classModifiers={"reset-password"}
        buttons={[{ text: t("sendRecoveryLink"), onClick: this.handleResetPassword.bind(this) }]}
      >
        <IonLoading isOpen={this.state.loading} message={"Working ..."} />
        <h1>{t("resetPassword")}</h1>
        <p>
          {t("enterEmailAddress")}
          <br />
          {t("recoveryLinkWillBeSent")}
        </p>

        <div className="entry">
          <div className="ion-margin-vertical">
            {this.renderInput({
              name: "Email Address",
              description: "",
              status: "1",
              value: null,
              key: "email",
              type: "email",
              rules: ["required"],
            })}
          </div>
        </div>
        <ModalConfirmation
          heading={t("checkYourEmail")}
          background="tertiary"
          isOpen={this.state.confirmationModalOpen}
          text={t("recoveryLinkWillBeSent")}
          closeModal={this.closeConfirmationModal.bind(this)}
          buttons={[
            {
              text: t("Ok"),
              onClick: this.closeConfirmationModal.bind(this),
            },
          ]}
        />
      </ModalConfirmation>
    );
  }

  closeConfirmationModal() {
    this.setState({ confirmationModalOpen: false });
    this.props.closeModal();
  }

  renderInput(question: Question) {
    const { formData, error } = this.state;

    return (
      <div className={`input__container input__container--type-${question.type} ${error && "has-error"}`}>
        <InputFactory
          className={"input__input input-factory__input input-factory__input--type-" + question.type}
          type={question.type}
          name={question.key}
          value={formData[question.key]}
          options={question.options}
          optionsFrom={question.optionsFrom}
          onIonChange={this.handleChange}
          rules={question.rules}
          placeholder={`${question.name} *`}
        />
        <IonNote color="danger">{error && error}</IonNote>
      </div>
    );
  }

  handleChange = (e: any) => {
    const { formData } = this.state;

    if (e.detail.value !== undefined) {
      formData[e.target.name] = e.detail.value;
    } else {
      delete formData[e.detail.name];
    }

    this.setState({ formData });
  };

  handleResetPassword = (e: any) => {
    const isMobile = window.innerWidth < 992;

    this.setState({
      loading: true,
      message: null,
      error: null,
    });

    ApiService.post("password/email", { email: this.state.formData["email"] })
      .then((res: any) => {
        if (res.error) {
          this.setState({
            loading: false,
            error: res.error,
          });
        } else {
          this.setState({
            loading: false,
            showModal: true,
            formData: {},
          });
          isMobile ? this.setState({ confirmationModalOpen: true }) : this.props.closeModal();
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err.message,
        });
      });
  };

  toggleModal = () => {
    this.props.history.push("/");
    this.setState({ showModal: !this.state.showModal });
  };
}

export default withTranslation()(ResetPassword);
